import { createElement, Fragment } from "react";
import { normalizeLocale } from "../config.js";
import { messages } from "./messages.js";
export const createTranslator = (localeValue) => {
    const locale = normalizeLocale(localeValue);
    const translate = ((key, values) => {
        var _a, _b;
        const template = (_b = (_a = readMessage(locale, key)) !== null && _a !== void 0 ? _a : readMessage("en", key)) !== null && _b !== void 0 ? _b : key;
        return interpolate(template, values);
    });
    translate.rich = ((key, values = {}) => {
        var _a, _b;
        const template = interpolate((_b = (_a = readMessage(locale, key)) !== null && _a !== void 0 ? _a : readMessage("en", key)) !== null && _b !== void 0 ? _b : key, Object.fromEntries(Object.entries(values).filter((entry) => typeof entry[1] !== "function")));
        const pattern = /<(\w+)>(.*?)<\/\1>/g;
        const parts = [];
        let lastIndex = 0;
        let match;
        while ((match = pattern.exec(template))) {
            if (match.index > lastIndex)
                parts.push(template.slice(lastIndex, match.index));
            const name = match[1];
            const chunks = match[2];
            if (!name || chunks === undefined)
                continue;
            const renderer = values[name];
            const content = typeof renderer === "function" ? renderer(chunks) : chunks;
            parts.push(content);
            lastIndex = pattern.lastIndex;
        }
        if (lastIndex === 0)
            return template;
        if (lastIndex < template.length)
            parts.push(template.slice(lastIndex));
        if (parts.every((part) => typeof part === "string" || typeof part === "number"))
            return parts.join("");
        return parts.map((part, index) => createElement(Fragment, { key: index }, part));
    });
    translate.locale = locale;
    return translate;
};
const readMessage = (locale, key) => {
    const parts = key.split(".");
    let current = messages[locale];
    for (const part of parts) {
        if (!current || typeof current !== "object")
            return undefined;
        current = current[part];
    }
    return typeof current === "string" ? current : undefined;
};
const interpolate = (template, values = {}) => template.replace(/\{(\w+)\}/g, (_match, key) => { var _a; return String((_a = values[key]) !== null && _a !== void 0 ? _a : ""); });
//# sourceMappingURL=translator.js.map